var cov_2c42ew74eg = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Table/Sorter.tsx",
      hash = "86196a1a2364e0692736e819f9477d83e428473d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Table/Sorter.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 16
        }
      },
      "1": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 46
        }
      },
      "2": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 48
        }
      },
      "3": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 29
        }
      },
      "4": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 29
        }
      },
      "5": {
        start: {
          line: 21,
          column: 51
        },
        end: {
          line: 21,
          column: 61
        }
      },
      "6": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 34
        }
      },
      "7": {
        start: {
          line: 22,
          column: 28
        },
        end: {
          line: 22,
          column: 34
        }
      },
      "8": {
        start: {
          line: 23,
          column: 17
        },
        end: {
          line: 23,
          column: 33
        }
      },
      "9": {
        start: {
          line: 24,
          column: 20
        },
        end: {
          line: 24,
          column: 70
        }
      },
      "10": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 88
        }
      },
      "11": {
        start: {
          line: 25,
          column: 50
        },
        end: {
          line: 25,
          column: 88
        }
      },
      "12": {
        start: {
          line: 29,
          column: 55
        },
        end: {
          line: 29,
          column: 65
        }
      },
      "13": {
        start: {
          line: 30,
          column: 17
        },
        end: {
          line: 30,
          column: 52
        }
      },
      "14": {
        start: {
          line: 30,
          column: 35
        },
        end: {
          line: 30,
          column: 51
        }
      },
      "15": {
        start: {
          line: 31,
          column: 21
        },
        end: {
          line: 31,
          column: 51
        }
      },
      "16": {
        start: {
          line: 32,
          column: 23
        },
        end: {
          line: 32,
          column: 51
        }
      },
      "17": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 55
        }
      },
      "18": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 28
        }
      },
      "19": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 29
        }
      },
      "20": {
        start: {
          line: 45,
          column: 51
        },
        end: {
          line: 45,
          column: 61
        }
      },
      "21": {
        start: {
          line: 46,
          column: 17
        },
        end: {
          line: 46,
          column: 52
        }
      },
      "22": {
        start: {
          line: 46,
          column: 35
        },
        end: {
          line: 46,
          column: 51
        }
      },
      "23": {
        start: {
          line: 47,
          column: 19
        },
        end: {
          line: 47,
          column: 25
        }
      },
      "24": {
        start: {
          line: 48,
          column: 27
        },
        end: {
          line: 48,
          column: 77
        }
      },
      "25": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 77,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        loc: {
          start: {
            line: 6,
            column: 51
          },
          end: {
            line: 10,
            column: 3
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        loc: {
          start: {
            line: 12,
            column: 22
          },
          end: {
            line: 14,
            column: 3
          }
        },
        line: 12
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 23
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 16
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        loc: {
          start: {
            line: 20,
            column: 23
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 50
          },
          end: {
            line: 34,
            column: 3
          }
        },
        line: 28
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 30,
            column: 30
          },
          end: {
            line: 30,
            column: 31
          }
        },
        loc: {
          start: {
            line: 30,
            column: 35
          },
          end: {
            line: 30,
            column: 51
          }
        },
        line: 30
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        },
        loc: {
          start: {
            line: 36,
            column: 14
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 36
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 15
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 40
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 44,
            column: 11
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 44
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 46,
            column: 30
          },
          end: {
            line: 46,
            column: 31
          }
        },
        loc: {
          start: {
            line: 46,
            column: 35
          },
          end: {
            line: 46,
            column: 51
          }
        },
        line: 46
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 26
          },
          end: {
            line: 21,
            column: 38
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 21,
            column: 36
          },
          end: {
            line: 21,
            column: 38
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 34
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 34
          }
        }],
        line: 22
      },
      "2": {
        loc: {
          start: {
            line: 23,
            column: 17
          },
          end: {
            line: 23,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 17
          },
          end: {
            line: 23,
            column: 27
          }
        }, {
          start: {
            line: 23,
            column: 31
          },
          end: {
            line: 23,
            column: 33
          }
        }],
        line: 23
      },
      "3": {
        loc: {
          start: {
            line: 24,
            column: 20
          },
          end: {
            line: 24,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 20
          },
          end: {
            line: 24,
            column: 39
          }
        }, {
          start: {
            line: 24,
            column: 43
          },
          end: {
            line: 24,
            column: 70
          }
        }],
        line: 24
      },
      "4": {
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 88
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 88
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 88
          }
        }],
        line: 25
      },
      "5": {
        loc: {
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 20
          }
        }, {
          start: {
            line: 25,
            column: 24
          },
          end: {
            line: 25,
            column: 32
          }
        }, {
          start: {
            line: 25,
            column: 36
          },
          end: {
            line: 25,
            column: 48
          }
        }],
        line: 25
      },
      "6": {
        loc: {
          start: {
            line: 28,
            column: 35
          },
          end: {
            line: 28,
            column: 48
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 28,
            column: 44
          },
          end: {
            line: 28,
            column: 48
          }
        }],
        line: 28
      },
      "7": {
        loc: {
          start: {
            line: 29,
            column: 38
          },
          end: {
            line: 29,
            column: 50
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 29,
            column: 48
          },
          end: {
            line: 29,
            column: 50
          }
        }],
        line: 29
      },
      "8": {
        loc: {
          start: {
            line: 31,
            column: 21
          },
          end: {
            line: 31,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 21
          },
          end: {
            line: 31,
            column: 27
          }
        }, {
          start: {
            line: 31,
            column: 31
          },
          end: {
            line: 31,
            column: 51
          }
        }],
        line: 31
      },
      "9": {
        loc: {
          start: {
            line: 32,
            column: 23
          },
          end: {
            line: 32,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 34
          },
          end: {
            line: 32,
            column: 43
          }
        }, {
          start: {
            line: 32,
            column: 46
          },
          end: {
            line: 32,
            column: 51
          }
        }],
        line: 32
      },
      "10": {
        loc: {
          start: {
            line: 45,
            column: 12
          },
          end: {
            line: 45,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 45,
            column: 22
          },
          end: {
            line: 45,
            column: 24
          }
        }],
        line: 45
      },
      "11": {
        loc: {
          start: {
            line: 48,
            column: 27
          },
          end: {
            line: 48,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 27
          },
          end: {
            line: 48,
            column: 39
          }
        }, {
          start: {
            line: 48,
            column: 43
          },
          end: {
            line: 48,
            column: 77
          }
        }],
        line: 48
      },
      "12": {
        loc: {
          start: {
            line: 52,
            column: 9
          },
          end: {
            line: 75,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 53,
            column: 10
          },
          end: {
            line: 57,
            column: 12
          }
        }, {
          start: {
            line: 59,
            column: 10
          },
          end: {
            line: 74,
            column: 13
          }
        }],
        line: 52
      },
      "13": {
        loc: {
          start: {
            line: 54,
            column: 20
          },
          end: {
            line: 54,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 54,
            column: 29
          },
          end: {
            line: 54,
            column: 39
          }
        }, {
          start: {
            line: 54,
            column: 42
          },
          end: {
            line: 54,
            column: 51
          }
        }],
        line: 54
      },
      "14": {
        loc: {
          start: {
            line: 62,
            column: 36
          },
          end: {
            line: 62,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 36
          },
          end: {
            line: 62,
            column: 42
          }
        }, {
          start: {
            line: 62,
            column: 46
          },
          end: {
            line: 62,
            column: 66
          }
        }, {
          start: {
            line: 62,
            column: 70
          },
          end: {
            line: 62,
            column: 85
          }
        }],
        line: 62
      },
      "15": {
        loc: {
          start: {
            line: 69,
            column: 36
          },
          end: {
            line: 69,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 36
          },
          end: {
            line: 69,
            column: 42
          }
        }, {
          start: {
            line: 69,
            column: 46
          },
          end: {
            line: 69,
            column: 67
          }
        }, {
          start: {
            line: 69,
            column: 71
          },
          end: {
            line: 69,
            column: 86
          }
        }],
        line: 69
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0],
      "7": [0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0, 0],
      "15": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Table/Sorter.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { tableClass } from './styles';

var Sorter =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Sorter, _PureComponent);

  var _super = _createSuper2(Sorter);

  function Sorter(props) {
    var _this;

    _classCallCheck(this, Sorter);

    cov_2c42ew74eg.f[0]++;
    cov_2c42ew74eg.s[0]++;
    _this = _super.call(this, props);
    cov_2c42ew74eg.s[1]++;
    _this.handleAsc = _this.handleAsc.bind(_assertThisInitialized(_this));
    cov_2c42ew74eg.s[2]++;
    _this.handleDesc = _this.handleDesc.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Sorter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_2c42ew74eg.f[1]++;
      cov_2c42ew74eg.s[3]++;
      this.defaultSorterOrder();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      cov_2c42ew74eg.f[2]++;
      cov_2c42ew74eg.s[4]++;
      this.defaultSorterOrder();
    }
  }, {
    key: "defaultSorterOrder",
    value: function defaultSorterOrder() {
      cov_2c42ew74eg.f[3]++;

      var _ref = (cov_2c42ew74eg.s[5]++, this.props),
          defaultOrder = _ref.defaultOrder,
          _ref$current = _ref.current,
          current = _ref$current === void 0 ? (cov_2c42ew74eg.b[0][0]++, []) : _ref$current,
          keyStr = _ref.keyStr;

      cov_2c42ew74eg.s[6]++;

      if (current.length > 1) {
        cov_2c42ew74eg.b[1][0]++;
        cov_2c42ew74eg.s[7]++;
        return;
      } else {
        cov_2c42ew74eg.b[1][1]++;
      }

      var item = (cov_2c42ew74eg.s[8]++, (cov_2c42ew74eg.b[2][0]++, current[0]) || (cov_2c42ew74eg.b[2][1]++, {}));
      var changed = (cov_2c42ew74eg.s[9]++, (cov_2c42ew74eg.b[3][0]++, keyStr === item.key) && (cov_2c42ew74eg.b[3][1]++, defaultOrder === item.order));
      cov_2c42ew74eg.s[10]++;

      if ((cov_2c42ew74eg.b[5][0]++, defaultOrder) && (cov_2c42ew74eg.b[5][1]++, !changed) && (cov_2c42ew74eg.b[5][2]++, !item.manual)) {
        cov_2c42ew74eg.b[4][0]++;
        cov_2c42ew74eg.s[11]++;
        this.handleChange(defaultOrder, false);
      } else {
        cov_2c42ew74eg.b[4][1]++;
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(order) {
      var manual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2c42ew74eg.b[6][0]++, true);
      cov_2c42ew74eg.f[4]++;

      var _ref2 = (cov_2c42ew74eg.s[12]++, this.props),
          sorter = _ref2.sorter,
          keyStr = _ref2.keyStr,
          onChange = _ref2.onChange,
          _ref2$current = _ref2.current,
          current = _ref2$current === void 0 ? (cov_2c42ew74eg.b[7][0]++, []) : _ref2$current;

      var item = (cov_2c42ew74eg.s[13]++, current.find(function (v) {
        cov_2c42ew74eg.f[5]++;
        cov_2c42ew74eg.s[14]++;
        return v.key === keyStr;
      }));
      var isCancel = (cov_2c42ew74eg.s[15]++, (cov_2c42ew74eg.b[8][0]++, !!item) && (cov_2c42ew74eg.b[8][1]++, order === item.order));
      var finalOrder = (cov_2c42ew74eg.s[16]++, isCancel ? (cov_2c42ew74eg.b[9][0]++, undefined) : (cov_2c42ew74eg.b[9][1]++, order));
      cov_2c42ew74eg.s[17]++;
      onChange(finalOrder, sorter, keyStr, order, manual);
    }
  }, {
    key: "handleAsc",
    value: function handleAsc() {
      cov_2c42ew74eg.f[6]++;
      cov_2c42ew74eg.s[18]++;
      this.handleChange('asc');
    }
  }, {
    key: "handleDesc",
    value: function handleDesc() {
      cov_2c42ew74eg.f[7]++;
      cov_2c42ew74eg.s[19]++;
      this.handleChange('desc');
    }
  }, {
    key: "render",
    value: function render() {
      cov_2c42ew74eg.f[8]++;

      var _ref3 = (cov_2c42ew74eg.s[20]++, this.props),
          _ref3$current = _ref3.current,
          current = _ref3$current === void 0 ? (cov_2c42ew74eg.b[10][0]++, []) : _ref3$current,
          keyStr = _ref3.keyStr,
          renderSorter = _ref3.renderSorter;

      var item = (cov_2c42ew74eg.s[21]++, current.find(function (v) {
        cov_2c42ew74eg.f[9]++;
        cov_2c42ew74eg.s[22]++;
        return v.key === keyStr;
      }));
      var active = (cov_2c42ew74eg.s[23]++, !!item);
      var isCustomRender = (cov_2c42ew74eg.s[24]++, (cov_2c42ew74eg.b[11][0]++, renderSorter) && (cov_2c42ew74eg.b[11][1]++, typeof renderSorter === 'function'));
      cov_2c42ew74eg.s[25]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: tableClass('sorter-container'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 51,
            columnNumber: 7
          }
        }, isCustomRender ? (cov_2c42ew74eg.b[12][0]++, renderSorter({
          status: active ? (cov_2c42ew74eg.b[13][0]++, item.order) : (cov_2c42ew74eg.b[13][1]++, undefined),
          triggerAsc: this.handleAsc,
          triggerDesc: this.handleDesc
        })) : (cov_2c42ew74eg.b[12][1]++,
        /*#__PURE__*/
        React.createElement(React.Fragment, null,
        /*#__PURE__*/
        React.createElement("a", {
          key: "asc",
          className: tableClass((cov_2c42ew74eg.b[14][0]++, active) && (cov_2c42ew74eg.b[14][1]++, item.order === 'asc') && (cov_2c42ew74eg.b[14][2]++, 'sorter-active'), 'sorter-asc'),
          onClick: this.handleAsc,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 60,
            columnNumber: 13
          }
        }, "\xA0"),
        /*#__PURE__*/
        React.createElement("a", {
          key: "desc",
          className: tableClass((cov_2c42ew74eg.b[15][0]++, active) && (cov_2c42ew74eg.b[15][1]++, item.order === 'desc') && (cov_2c42ew74eg.b[15][2]++, 'sorter-active'), 'sorter-desc'),
          onClick: this.handleDesc,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 67,
            columnNumber: 13
          }
        }, "\xA0"))))
      );
    }
  }]);

  return Sorter;
}(PureComponent);

export default Sorter;